import Cookie from '@component/common/src/util/Cookie';
import Logger from '@component/common/src/util/Logger';

const KJUR = require('jsrsasign');

const guid = Cookie.get('macys_online_guid') ? Cookie.get('macys_online_guid') : Cookie.get('bloomingdales_online_guid');

// The tmxOrgId is a hardcoded value that Citi expects depending on
// whether this is being run in a dev or prod environment
const getTmxOrgId = function (isProd) {
  if (isProd) {
    return '530q7tul';
  }
  return '4ys85k3c';
};
const isProd = window.location.host.includes('macys.com') || window.location.host.includes('bloomingdales.com');
const tmxOrgId = getTmxOrgId(isProd);

// Below is a script provided by Citi to generate and send a new tmx session id
window.getNewTmxSessionId = function () {
  function getuuid() {
    const uuid = KJUR.crypto.Util.getRandomHexOfNbytes(16);
    return uuid;
  }

  function generateSessionID() {
    const date = new Date();
    const strToHash = `${date.toString() + getuuid()}WEB_BROWSER`;
    const hash = KJUR.crypto.Util.sha256(strToHash).toString();
    return hash;
  }

  function tmxProfilingComplete(sessionID) {
    try {
      if (sessionID != null) {
        const profilingTag = document.getElementById(sessionID);
        profilingTag.parentNode.removeChild(profilingTag);
        window.removeEventListener(
          'profiling-complete',
          tmxProfilingComplete,
        );
        Logger.info('tmxProfilingComplete without any errors', sessionID);
        Logger.log('tmxProfilingComplete without any errors', sessionID);
      }
    } catch (err) {
      console.warn('Error in profiling-  tmx');
      Logger.info(`TMX Session ID is null on tmxProfilingComplete() for user guid: ${guid} with sessionId:`, sessionID);
      Logger.log(`TMX Session ID is null on tmxProfilingComplete() for user guid: ${guid} with sessionId:`, sessionID);
    }
  }

  function getTmxSessionId() {
    let tmxSessionId;
    try {
      const head = document.getElementsByTagName('head').item(0);
      const script = document.createElement('script');
      script.setAttribute('type', 'text/javascript');
      const sessionID = generateSessionID();
      if (sessionID === null || sessionID === undefined || sessionID === '') {
        Logger.info(`TMX Session ID is null on getTmxSessionId() for user guid: ${guid} with sessionId:`, sessionID);
        Logger.log(`TMX Session ID is null on getTmxSessionId() for user guid: ${guid} with sessionId:`, sessionID);
      }
      script.setAttribute('id', sessionID);
      script.setAttribute(
        'src',
        `https://content22.citibankonline.com/tags.js?org_id=${tmxOrgId}&session_id=${
          sessionID}&page_id=1&allow_reprofile=1`,
      );
      head.appendChild(script);
      if (window.addEventListener) {
        window.addEventListener(
          'profiling-complete',
          tmxProfilingComplete(sessionID), false,
        );
      }
      tmxSessionId = sessionID;
      Logger.info('In getTmxSessionId() tmxProfilingComplete without any errors with tmxSessionId:', tmxSessionId);
      Logger.log('In getTmxSessionId() tmxProfilingComplete without any errors with tmxSessionId:', tmxSessionId);
      return tmxSessionId;
    } catch (err) {
      console.warn('Error in profiling-  tmx');
      Logger.info(`TMX Session ID is null on getTmxSessionId() catch block for user guid: ${guid} with sessionId:`, tmxSessionId);
      Logger.log(`TMX Session ID is null on getTmxSessionId() catch block for user guid: ${guid} with sessionId:`, tmxSessionId);
    }
    return tmxSessionId;
  }

  return getTmxSessionId();
};

/* eslint-disable */
export {
    getTmxOrgId,
    isProd,
  };
  /* eslint-enable */
